import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { EquipmentLogbookModel } from 'src/app/models/archive/equipment-logbook.model';
import { EquipmentLogbookPrintModel } from 'src/app/models/archive/equipment-loogbook-print.model';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { EquipmentLogbookImportModel } from 'src/app/models/imports/equipment-logbook-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EquipmentLogbookService {

  constructor(private _httpClient: HttpClient) { }

  attachFileToInvoice(equipmentLogbookId: number, file: FormData): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.equipmentLogbook.AttachFileToInvoiceAsync}/${equipmentLogbookId}`, file);
  }

  createEquipmentLogbook(equipmentLogbookContractModel: EquipmentLogbookModel): Observable<EquipmentLogbookModel> {
    return this._httpClient.post<EquipmentLogbookModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.equipmentLogbook.CreateAsync}`,
      equipmentLogbookContractModel
    );
  }

  deleteFileToInvoice(equipmentLogbookId: number, file: string): Observable<Array<string>> {
    const itemFilterResponse = new ItemFilterModel("file", null, equipmentLogbookId, file);
    return this._httpClient.post<Array<string>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.equipmentLogbook.DeleteFileToInvoice}`,
      itemFilterResponse
    );
  }

  downloadFileToInvoice(equipmentLogbookId: number, file: string): Observable<HttpEvent<Blob>> {
    const itemFilterResponse = new ItemFilterModel("file", null, equipmentLogbookId, file);
    return this._httpClient.request(new HttpRequest('POST', `${environment.apiCervinoBackend}${enpointCervinoWeb.equipmentLogbook.DownloadFileToInvoice}`,
      itemFilterResponse, { reportProgress: true, responseType: 'blob' })
    );
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.equipmentLogbook.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' })
    );
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.equipmentLogbook.ExportGeneralConsultation}`,
      filters, { params, responseType: 'blob' });
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.equipmentLogbook.ExportImportErrors}`,
      alerts, { responseType: 'blob' }
    );
  }

  getAllEquipmentLogbooksWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.equipmentLogbook.GetAllEquipmentLogbooksWithPagination}`,
      filters, { params: params }
    );
  }

  getAllProvidersForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.equipmentLogbook.GetAllProvidersForSelectAsync}`,);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.equipmentLogbook.GetColumnsForGeneralConsultation}`);
  }

  getEquipmentLogbookByArticleIdAsync(articleId: number): Observable<EquipmentLogbookModel> {
    return this._httpClient.get<EquipmentLogbookModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.equipmentLogbook.GetEquipmentLogbookByArticleIdAsync}/${articleId}`);
  }

  getEquipmentLogbookById(equipmentLogbookId: number): Observable<EquipmentLogbookModel> {
    return this._httpClient.get<EquipmentLogbookModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.equipmentLogbook.GetByIdAsync}/${equipmentLogbookId}`);
  }

  getEquipmentLogbookByKeysByPrintAsync(companyId: number, consecutive: number, articleId: number): Observable<EquipmentLogbookPrintModel> {
    const params = new HttpParams().set('companyId', companyId).set('consecutive', consecutive).set('articleId', articleId);
    return this._httpClient.get<EquipmentLogbookPrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.equipmentLogbook.GetEquipmentLogbookByKeysByPrintAsync}`,
      { params }
    );
  }

  getEmptyEquipmentLogbook(): Observable<EquipmentLogbookPrintModel> {
    return this._httpClient.get<EquipmentLogbookPrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.equipmentLogbook.GetEmptyEquipmentLogbookPrint}`);
  }

  importEquipmentLogbooks(equipmentLogbookImports: Array<EquipmentLogbookImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.equipmentLogbook.ImportEquipmentLogbooksAsync}`,
      equipmentLogbookImports
    );
  }

  updateArticle(equipmentLogbookContractModel: EquipmentLogbookModel): Observable<EquipmentLogbookModel> {
    return this._httpClient.put<EquipmentLogbookModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.equipmentLogbook.UpdateAsync}`,
      equipmentLogbookContractModel
    );
  }
}
